import {
    ADJUSTMENTS_FETCH,
    ADJUSTMENTS_IS_FETCING,
    ADJUSTMENT_FILTER,
    SET_ADJUSTMENT_VIEW_FILTER,
    ADJUSTMENT_EDIT,
    UPDATE_ADJUSTMENT_STATUS
} from 'constants/adjustments'

export default function adjustmentsReducer(state = {
    reasonsList: [],
    reasonsListAll: [],
    list: [],
    pageable: {
        sort: {
            'status': 'asc',
            'changeStatusTime': 'asc',
            'commentText': 'asc',
            'comment': 'asc',
            'description': 'asc',
            'adjustmentId': false,
            'usdAmount': false,
            'ibId': false,
            'creationTime': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case ADJUSTMENTS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case ADJUSTMENT_EDIT:
            return {
                ...state,
            }
        case ADJUSTMENTS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
						}
				case UPDATE_ADJUSTMENT_STATUS:
						state.list.find((item, i) => item.adjustmentId === action.payload.adjustmentId).status = action.payload.status
						return {
							...state,
							list: [...state.list]
						}
        case ADJUSTMENT_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
         case SET_ADJUSTMENT_VIEW_FILTER:
          return {
              ...state,
              [action.payload.filterName]: action.payload.value 
          }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/adjustments.js